import styled, { css } from 'styled-components'

export const StickyPreviewContainer = styled.div`
  position: sticky;
  top: 5rem;
  display: flex;
  flex-direction: column;
`

export const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${props => props.theme.primitives.radius.radius6};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.secondary};
`

export const TypeSection = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.background.primary};

  &:last-of-type {
    border-radius: ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius0}
      ${props => props.theme.primitives.radius.radius3} ${props => props.theme.primitives.radius.radius3};
  }
`

export const SectionDivider = styled.div`
  padding: 0 ${props => props.theme.spacing.sp16};
`

export const TypeContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
`

export const SubTabsSection = styled.div`
  background-color: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.primitives.radius.radius3} ${props => props.theme.primitives.radius.radius3}
    ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius0};
  padding: ${props => props.theme.spacing.sp16};
  padding-bottom: 0;

  .MuiTabs-scroller {
    background-color: ${props => props.theme.colors.background.secondary};
  }
`

export const ColorsContainer = styled.div`
  display: grid;

  grid-template-columns: 1fr 1fr;
  grid-gap: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp40};

  & > div > div > div:first-child {
    min-width: ${props => props.theme.size.L};
    min-height: ${props => props.theme.size.L};
  }

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`

export const PreviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp32};
  background-color: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.primitives.radius.radius3};
`

export const AlertWrapper = styled.div`
  padding-top: ${props => props.theme.spacing.sp16};
`

export const PreviewToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: ${props => props.theme.spacing.sp4};
  border-radius: 2rem;

  &:hover {
    background-color: ${props => props.theme.colors.disabled.surface};
  }

  ${props =>
    props.active &&
    css`
      background-color: ${props.theme.colors.outline.default};

      &:hover {
        background-color: ${props.theme.colors.outline.default};
      }
    `}
`
